import { Component } from '@theme/component';

/**
 * Filament Finder custom component.
 * Manages tab toggles (Application vs. Property) and active details selection.
 *
 * @extends {Component}
 */
export class FilamentFinderComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    
    // Set initial active state
    const firstTab = this.querySelector('.filament-finder__tab-btn');
    if (firstTab) {
      this.selectTab(firstTab.dataset.tab);
    }
  }

  /**
   * Toggles the active category tab (Applications vs. Properties)
   * @param {string} tabId - The ID of the tab to select
   * @param {Event} [event] - Optional click event
   */
  selectTab(tabId, event) {
    if (event) event.preventDefault();

    // Update tab button active states
    const tabButtons = this.querySelectorAll('.filament-finder__tab-btn');
    tabButtons.forEach(btn => {
      const isActive = btn.dataset.tab === tabId;
      btn.classList.toggle('active', isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    // Update panel active states
    const panels = this.querySelectorAll('.filament-finder__panel');
    panels.forEach(panel => {
      panel.classList.toggle('active', panel.dataset.panelId === tabId);
    });

    // Auto-select the first option button of the active panel
    const activePanel = this.querySelector(`.filament-finder__panel[data-panel-id="${tabId}"]`);
    const firstOption = activePanel?.querySelector('.filament-finder__option-btn');
    if (firstOption) {
      this.selectOption(firstOption.dataset.option);
    }
  }

  /**
   * Toggles the active option selection and reveals its detail card
   * @param {string} optionId - The ID of the option selected
   * @param {Event} [event] - Optional click event
   */
  selectOption(optionId, event) {
    if (event) event.preventDefault();

    // Update option button active states
    const optionButtons = this.querySelectorAll('.filament-finder__option-btn');
    optionButtons.forEach(btn => {
      btn.classList.toggle('active', btn.dataset.option === optionId);
    });

    // Update detail card active states
    const detailCards = this.querySelectorAll('.filament-finder__detail-card');
    detailCards.forEach(card => {
      card.classList.toggle('active', card.dataset.detailId === optionId);
    });
  }
}

if (!customElements.get('filament-finder-component')) {
  customElements.define('filament-finder-component', FilamentFinderComponent);
}
